var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "terms-of-service-app" } },
    [
      _c("Modal", { staticClass: "termsOfServiceModal" }, [
        _c("div", { attrs: { slot: "header" }, slot: "header" }),
        _vm._v(" "),
        _c("div", { attrs: { slot: "body" }, slot: "body" }, [
          !_vm.managing
            ? _c("section", { staticClass: "defaultBody" }, [
                _c("h4", [
                  _vm._v("Acknowlege Terms (required to use the service)"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "documents" }, [
                  _vm._v(
                    "By continuing, you aknowledge that you have read and understand HP's \n          "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.hp.com/us-en/privacy/privacy-central.html",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Privacy Statement")]
                  ),
                  _vm._v(",\n          "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
                        target: "_blank",
                      },
                    },
                    [_vm._v("EULA")]
                  ),
                  _vm._v(",\n          and "),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
                        target: "_blank",
                      },
                    },
                    [_vm._v("DPA")]
                  ),
                ]),
                _vm._v(" "),
                _c("h4", [_vm._v("Optional Privacy Consents")]),
                _vm._v(" "),
                !_vm.brandingService.isGov() &&
                _vm.userObject &&
                _vm.userObject.isUserAdmin()
                  ? _c("p", { staticClass: "documents" }, [
                      _vm._v(
                        "Agree to HP collecting and using your personal data to provide, develop, and improve the quality of our service, security, products, applications and operations, to deliver products and drive continuous improvements."
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "documents" }, [
                  _vm._v(
                    "I consent to recieve communications from HP, which I understand I may opt out of at any time."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "consentButton btn btn-primary",
                    on: { click: _vm.consent },
                  },
                  [_vm._v("Accept All")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "consentButton btn btn-default",
                    on: { click: _vm.manage },
                  },
                  [_vm._v("Manage Options")]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "consentFooter" }, [
                  _vm._v(
                    "Accept All applies only to Optional Privacy Consents"
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.managing
            ? _c(
                "section",
                { staticClass: "manageBody" },
                [
                  _c("div", { staticClass: "termsOutline" }, [
                    _c("div", { staticClass: "left" }, [
                      _c("h4", [
                        _vm._v(
                          "Acknowlege Terms (required to use the service)"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "documents" }, [
                        _vm._v(
                          "\n              By continuing, you aknowledge that you have read and understand HP's \n              "
                        ),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.hp.com/us-en/privacy/privacy-central.html",
                              target: "_blank",
                            },
                          },
                          [_vm._v("Privacy Statement")]
                        ),
                        _vm._v(",\n              "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
                              target: "_blank",
                            },
                          },
                          [_vm._v("EULA")]
                        ),
                        _vm._v(",\n              and "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
                              target: "_blank",
                            },
                          },
                          [_vm._v("DPA")]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "legend-title legend-switch action-switch",
                          attrs: { align: "left" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.termsAccepted,
                                expression: "termsAccepted",
                              },
                            ],
                            attrs: {
                              id: "enabled",
                              type: "checkbox",
                              checked: "",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.termsAccepted)
                                ? _vm._i(_vm.termsAccepted, null) > -1
                                : _vm.termsAccepted,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.termsAccepted,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.termsAccepted = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.termsAccepted = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.termsAccepted = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "legend-slider" }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Optional Privacy Consents")]),
                  _vm._v(" "),
                  !_vm.brandingService.isGov() &&
                  _vm.userObject &&
                  _vm.userObject.isUserAdmin()
                    ? _c("v-checkbox", {
                        staticClass: "communications",
                        attrs: {
                          label:
                            "Agree to HP collecting and using your personal data to provide, develop, and improve the quality of our service, security, products, applications and operations, to deliver products and drive continuous improvements.",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.orgDataConsent,
                          callback: function ($$v) {
                            _vm.orgDataConsent = $$v
                          },
                          expression: "orgDataConsent",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    staticClass: "communications",
                    attrs: {
                      label:
                        "I consent to recieve communications from HP, which I understand I may opt out of at any time.",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.userCommunicationConsent,
                      callback: function ($$v) {
                        _vm.userCommunicationConsent = $$v
                      },
                      expression: "userCommunicationConsent",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "consentButton btn btn-primary",
                      attrs: { disabled: !_vm.termsAccepted },
                      on: { click: _vm.consent },
                    },
                    [_vm._v("Save")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "consentButton btn btn-default",
                      on: { click: _vm.manage },
                    },
                    [_vm._v("Cancel")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }